"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$title = _ref.title,
    modTitle = _ref$title === void 0 ? '' : _ref$title,
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$card = _ref.card,
    card = _ref$card === void 0 ? {} : _ref$card,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  const _ref2 = card || {},
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title,
    _ref2$desc = _ref2.desc,
    desc = _ref2$desc === void 0 ? '' : _ref2$desc,
    img = _ref2.img,
    btnText = _ref2.btnText,
    btnHref = _ref2.btnHref;
  const btnExtendProps = {
    'report-event': 'click_TransferFooter_topCard_button',
    'report-ext1': btnText || '',
    'report-ext2': btnHref || '',
    'target': '_blank'
  };
  const handledLogoList = items === null || items === void 0 ? void 0 : items.map((activityItem, index) => {
    const _ref3 = activityItem || {},
      title = _ref3.title,
      desc = _ref3.desc,
      img = _ref3.img,
      btnText = _ref3.btnText,
      btnHref = _ref3.btnHref;
    const btnExtendProps = {
      'report-event': 'click_TransferFooter_bottomCard_button',
      'report-ext1': index,
      'report-ext2': btnText || '',
      'report-ext3': btnHref || '',
      'target': '_blank'
    };
    return {
      title,
      desc,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      btn: btnText ? /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        type: 'weak',
        icon: true,
        href: btnHref
      }, btnExtendProps), btnText) : /*#__PURE__*/React.createElement(React.Fragment, null)
    };
  });
  return {
    porintId,
    title: modTitle ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: modTitle
    }) : '',
    bg,
    card: {
      title,
      desc,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      btn: btnText ? /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        type: 'solid-white',
        icon: true,
        href: btnHref
      }, btnExtendProps), btnText) : /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    items: handledLogoList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  console.log('formatAdvantageCommon--', data);
  if (data && Object.keys(data).length > 1) {
    const heroData = formatAdvantageCommon(data, {
      domains
    });
    console.log(heroData);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: (heroData === null || heroData === void 0 ? void 0 : heroData.porintId) || (heroData === null || heroData === void 0 ? void 0 : heroData.title),
      className: "gems-materials-qci__newUI-transferFooter"
    }, (0, _reportUtil.reportShow)(['show_newUI_TransferFooter', componentKey, (heroData === null || heroData === void 0 ? void 0 : heroData.title) || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      bg: heroData === null || heroData === void 0 ? void 0 : heroData.bg,
      title: (heroData === null || heroData === void 0 ? void 0 : heroData.title) || ''
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Advance, {
      card: heroData === null || heroData === void 0 ? void 0 : heroData.card,
      items: heroData === null || heroData === void 0 ? void 0 : heroData.items
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}